import * as React from "react";
import {useState, useEffect} from "react";
import "./styles.scss";
import {shouldDisableScroll} from "utils";

const NetworkStatus = () => {
  const [networkStatus, setNetworkStatus] = useState(window.navigator.onLine);
  const [showNetworkStatus, setShowNetworkStatus] = useState(false || !window.navigator.onLine);
  let timerId = null;

  useEffect(() => {
    const handleOnline = () => {
      setNetworkStatus(true);
      setShowNetworkStatus(true);
      shouldDisableScroll({element: document.body, disabled: false});
      const timer = () => setTimeout(() => setShowNetworkStatus(false), 5000);
      timerId = timer();
    };

    const handleOffline = () => {
      clearTimeout(timerId);
      setNetworkStatus(false);
      setShowNetworkStatus(true);
      shouldDisableScroll({element: document.body, disabled: true});
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearTimeout(timerId);
    };
  }, []);

  return <>
    {showNetworkStatus && <div className={`network-status ${networkStatus ? "online" : "offline"}`}>
      You are {networkStatus ? "back online" : "offline"}</div>}
  </>;
};

export default NetworkStatus;
